// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loop-trial-success-modal__icon-wrap[data-v-6fd5bf02]{\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  width:72px;\n  height:72px;\n  border-radius:50%;\n  background:#f0fdfa;\n  color:#14b8a6\n}\n.loop-trial-success-modal__icon-wrap[data-v-6fd5bf02] svg.icon-svg{\n  display:block;\n  width:30px;\n  height:30px;\n  flex-shrink:0\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
